<div class="w-full p-gutter text-center">
    <img class="w-full max-w-lg mx-auto mb-6" src="assets/img/illustrations/data_center.svg">
  
    <h1 class="display-3 font-medium m-0">Error</h1>
    <h2 class="headline m-0">An expected error happened </h2>

  </div>
  